<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>

      <v-row class="pa-2" no-gutters >
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <gallery-mobile v-model="data" :orders.sync="data.orders" />
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات مدل قاب خاطره ها</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="data.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام مدل قاب خاطره ها شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام مدل قاب خاطره ها"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion
                v-model="data"
                :components="specialInfo"
                :data="data"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import { mapActions, mapGetters } from "vuex";
import VideoGalleryMobile from "@/view/pages/otherQrTypes/giftGallery/components/galleryMobile";
import GalleryMobile from "@/view/pages/otherQrTypes/giftGallery/components/galleryMobile.vue";
import QrEditGateway from "@/view/pages/qrland/components/QrEditGateway.vue";

export default {
  name: "editGitfGalleryModel",

  props:{
    id:{type:String, default:''},
  },
  components: {
    HelpInfo,
    HelpInfoWrapper,
    GalleryMobile,
    VideoGalleryMobile,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    QrEditGateway
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "editPhoto",
      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: true,
      loading: false,
      errors: {},
      data: {},
      security: {},
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
 specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "داستان هدیه",
          icon: "account-heart-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "تصویر پروفایل",
          icon: "camera-plus",
          model: "photo",
        },
        {
          name: "bannerSelector",
          value: "",
          title: "تصاویر منتخب",
          icon: "panorama",
          model: "banner",
        },
        { name: "PicSelector", value: "", title: "گالری تصویر", icon: "image-multiple" },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video",
        },
        {
          name: "voiceGallery",
          title: "افزودن فایل صوتی",
          icon: "microphone",
          model: "audiosGallery",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
        };
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    domainName() {
      return this.$route.params?.domain;
    },
    iden() {
      return this.$route.params?.iden;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    
    onCancel() {
      this.goto('qr/list');
    },
    
       fetchData() {
      this.loading = true;

      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          this.loading = false;
          this.setCreatedQrID(data.data.id);
          this.res = data;
          // 1. استخراج و پارس کردن دیتای Qr
          let parsedQrData = typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;
          
          // 2. اصلاح کلیدی: اختصاص دیتای درونی به this.data
          // اگر ساختار تو در تو بود (parsedQrData.data وجود داشت)، آن را می‌گیریم
          this.data = parsedQrData.data ? parsedQrData.data : parsedQrData;
          console.log(this.data.visitName,"res")

          // 3. مقداردهی‌های پیش‌فرض
          if (!this.data.orders) {
            this.$set(this.data, 'orders', [        
              { name: 'profile' },
              { name: 'organizationInfo' },
              { name: 'headerImage' },
              { name: 'memories' }, 
              { name: 'gallery' },
              { name: 'video_gallery' },
              { name: 'audiosGallery' },
              { name: 'website' },
              { name: 'aboutUs' },
            ]);
          }
          if (this.data.banner && !this.data.banner.mode) {
             this.$set(this.data.banner, 'mode', 'grid');
          }
          
        })
        .finally(() => (this.loading = false));
    },

    markQr(final = false) {
      this.loading = true;
       this.loading = true;
      let obj = {
        type: "gift",
        qrType: "dynamic",
        title: this.data.visitName,
        data: JSON.stringify({
          theme: '',
          data: this.data,
        }),
        qr_id: this.res.qrId,
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "gift",
          title: this.data.visitName,
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("گیوار قاب خاطره ها شما با موفقیت ویرایش شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.cardTexts = {
        orders: [     
            { name: 'profile' },
            { name: 'organizationInfo' },
            { name: 'headerImage' },
            { name: 'memories' }, 
            { name: 'gallery' },
            { name: 'video_gallery' },
            { name: 'audiosGallery' },
            { name: 'website' },
            { name: 'aboutUs' },
        ],
        visitName: "",
        banner: {
          mode: "grid", //grid|slider
          gallery: [
            {
              images: [
                
              ],
              name: "",
            },
          ],
        },
        pallete: {
          headColor: "linear-gradient(to top, #050404FF, #3B1A4CFF)",
          bodyColor: "linear-gradient(to top right , #050404FF, #3B1A4CFF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        gallery: [
          {
            name: "",
            images: [
             
            ],
          },
          {
            name: "",
            images: [
            ],
          },
        ],
        photo: {
          profile: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
          audiosGallery: {
          audios: [
           
          ],
          audioType: "",
        },
         VideoGallery: {
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          title: "",
          description:'',
          slider: false,
          grid: false,
          secondPosition: false,
          name: "",
          images: [
            {
          
            },
          ],
        },
        video_gallery: [
          {
            name: "",
            images: [
              {
             },
            ],
          },
        ],
        organizationName: "",
        subtitle: "",
        website: "",
        memories:[
        ],

        PicSelector: {
          title: "",
          description: "",
          orientation:"horizontal",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          slider: false,
          grid: true,
        },
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #270DF5)",
            text: "#fff",
          },
          slider: false,
          grid: false,
        },
      };
    }
  }
}
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
